<template>
  <a-collapse
    v-model:activeKey="activeKey"
    expand-icon-position="right"
    :bordered="false"
  >
    <a-collapse-panel
      v-for="q in quarters"
      :key="q"
      style="border: 0"
    >
      <div
        v-if="!canEdit || getVisibleStatus(q)"
        :class="{result: true, pointer: canEdit}"
        @click="editHandler(q)"
      >
        <p class="review-title">
          {{ $t('okr.review.achievement') }}
        </p>
        <div v-html="reviews.get(q).progressAchievement || '无'" />
        <p class="review-title">
          {{ $t('okr.review.problem') }}
        </p>
        <div v-html="reviews.get(q).decisionIssue || '无'" />
        <FileList
          :can-edit="false"
          :files="JSON.parse(reviews.get(q).reviewAttachments || '[]')"
          :style="{ marginTop: '8px' }"
        />
      </div>
      <div v-else>
        <CreateButton
          :text="$t('okr.review.inputReview')"
          icon-name="iconbianji"
          :style="{ backgroundColor: '#F8F9FF', fontSize: '18px' }"
          @click="editHandler(q)"
        >
          <!-- <template #default>
            <EditFilled :style="{fontSize: '24px', color: '#0091FF'}" />
          </template> -->
        </CreateButton>
      </div>
      <template #header>
        <a-space :style="{ marginLeft: '24px' }">
          <IconFont
            type="iconfupanzongjie"
            :style="{ fontSize: '18px' }"
          />
          <span :style="{ fontWeight: 'bold'}">
            {{ `${q} ${$t('okr.review.title')}` }}
          </span>
        </a-space>
      </template>
    </a-collapse-panel>
  </a-collapse>
  <edit
    v-model:visible="visible"
    :objective="objective"
    :review="reviews.get(editQuarter)"
    v-bind="$attrs"
  />
</template>

<script>
import { computed, ref, toRefs } from 'vue'

import FileList from '@/components/FileList'
import Edit from './edit.vue'
import CreateButton from '@/components/CreateButton'
import { useStore } from 'vuex'
// import { EditFilled } from '@ant-design/icons-vue'

export default {
  components: {
    Edit,
    CreateButton,
    FileList
    // EditFilled
  },
  props: {
    objective: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    reverse: {
      type: Boolean,
      default: false
    },
    isMyManagementScope: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const store = useStore()
    const upload = ref(null)
    const { canEdit, reverse, isMyManagementScope } = toRefs(props)
    const visible = ref(false)
    const editQuarter = ref(undefined)
    function editHandler (q) {
      if (!canEdit.value) {
        return
      }
      editQuarter.value = q
      visible.value = true
    }

    const { objective } = toRefs(props)
    const displayYear = computed(() => {
      return Number((store.state.yearCycles[store.state.activeYearIndex])[0].displayName)
    })
    const lockStatus = computed(() => store.getters.lockStatus)

    // get quarter
    const quarters = (() => {
      const arr = ['Q1', 'Q2', 'Q3', 'Q4']
      // if (canEdit.value) {
      const currentYear = new Date().getFullYear()
      const month = new Date().getMonth()
      if (currentYear === displayYear.value) {
        arr.splice(Math.floor(month / 3))
      }
      // } else {
      //   arr = arr.filter((item) => {
      //     for (let i = 0; i < objective.value.reviews.length; i++) {
      //       const review = objective.value.reviews[i]
      //       if (review.reviewFlag === item) {
      //         return true
      //       }
      //     }
      //     return false
      //   })
      // }
      return reverse.value ? arr.reverse() : arr
    })()
    // end

    const reviews = computed(() => {
      const map = new Map()
      objective.value.reviews.forEach(item => {
        map.set(item.reviewFlag, item)
      })
      quarters.forEach(q => {
        if (!map.has(q)) {
          map.set(q, {
            reviewFlag: q
          })
        }
      })
      return map
    })
    const review = computed(() => reviews.value.get(editQuarter.value))

    const activeKey = ref(quarters.length > 0 && (!reverse.value || !lockStatus.value || !isMyManagementScope.value) ? [quarters[reverse.value ? 0 : quarters.length - 1]] : [])

    const getVisibleStatus = (q) => {
      const item = reviews.value.get(q)
      return 'id' in item && (item.progressAchievement || item.decisionIssue || item.reviewAttachments)
    }

    return {
      upload,
      activeKey,
      visible,
      editHandler,
      quarters,
      reviews,
      review,
      editQuarter,
      getVisibleStatus
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-collapse-content) > .ant-collapse-content-box {
  padding: 4px 44px 16px;
}

.review-title {
  font-weight: bold;

  &:not(:first-child) {
    margin-top: 1em;
  }
}

:deep(.ant-collapse-header) {
  display: flex;
  align-items: center;

  .ant-collapse-arrow {
    margin-left: 8px;
    position: static !important;
    order: 2;
    transform: none !important;
  }
}

:deep(.ant-collapse-content-box) {
  padding: 4px 9px 16px 9px !important;
}

.result {
  padding: 0 17px 0 43px;
}

.pointer {
  cursor: pointer;
}
</style>
